<ul [class.isDropdown]="showAsDropdown" [class.open]="open" [style.color]="themeColor" >
  <li *ngFor="let link of links">
    <a *ngIf="!link.linkToSite && link.externalUrl.length > 0" [href]="link.externalUrl"  [target]="link.openNewTab ? '_blank' : '_self'">{{link.name}}</a>
    <a *ngIf="link.linkToSite" [routerLink]="['']" [target]="link.openNewTab ? '_blank' : '_self'"  (click)="closeMenu.emit()" >{{link.name}}</a>
  </li>
</ul>
